/** @typedef {import('./Storage.svc')} Types */

export class Storage {
	constructor(localStorageService) {
		'ngInject';
		this.localStorageSvc = localStorageService;
	}

	/**
	 * @param {string} key
	 * @returns {any}
	 */
	get(key) {
		return this.localStorageSvc.get(key);
	}

	/**
	 * @param {string} key
	 * @param {unknown} val
	 * @returns {boolean}
	 */
	set(key, val) {
		return this.localStorageSvc.set(key, val);
	}

	/** @returns {string[]} */
	keys() {
		return this.localStorageSvc.keys();
	}

	/**
	 * @param {string} key
	 * @returns {boolean}
	 */
	remove(key) {
		return this.localStorageSvc.remove(key);
	}

	/** @returns {boolean} */
	clearAll() {
		return this.localStorageSvc.clearAll();
	}
}
//
let compMod = angular.module('mod.svc.StorageSvc', []).service('StorageSvc', Storage);
export default (compMod = compMod.name);
